import { ChargePoint } from '../common/redux/api/web-api'

const isSchukoEnabled = (chargePoint: ChargePoint): boolean => (chargePoint?.numberOfConnectors ?? 0) > 1

export default isSchukoEnabled
